import { CaseDrawer } from './CaseDrawer';
import { StaffDrawer } from './StaffDrawer';
import { TaskDrawer } from './TaskDrawer';
import { DRAWER_KIND_LABEL, useDrawerParams } from './useDrawerParams';

/** URL の ?case= / ?staff= / ?task= に応じて詳細ドロワーを出す。AppShell に 1 つだけ置く。 */
export const DrawerHost = () => {
  const { caseId, staffId, taskId, origin, back, close } = useDrawerParams();
  // 別のドロワーの中から開いたときだけ、遷移元に戻るボタンを出す(表の行や直接のリンクからなら出さない)
  const backLink =
    origin === null
      ? undefined
      : { label: `← ${DRAWER_KIND_LABEL[origin.kind]} ${origin.id} に戻る`, onClick: back };
  if (caseId !== null) return <CaseDrawer id={caseId} onClose={close} back={backLink} />;
  if (staffId !== null) return <StaffDrawer id={staffId} onClose={close} back={backLink} />;
  if (taskId !== null) return <TaskDrawer id={taskId} onClose={close} back={backLink} />;
  return null;
};
